import { Pipe, PipeTransform } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({name: 'monthsToYears'})
export class MonthsToYearsPipe implements PipeTransform {
  constructor(private translateService: TranslateService) { }
    transform(value: number) {
        return parseInt((value/12).toString()) + ' ' + this.translateService.instant('controlPanel.numberQuestion.years') + ' ' +  value%12 + ' ' + this.translateService.instant('controlPanel.numberQuestion.months');
    }
}
